<template>
  <div>
    <v-assist-claim v-if="typeCode==='CLAIM'" :itemId="id" :typeCode="typeCode"></v-assist-claim>
    <v-assist-deed v-if="['DEED', 'BINDER', 'POST', 'CONTRACTOR_CHECK'].includes(typeCode)" :itemId="id" :typeCode="typeCode"></v-assist-deed>
    <v-assist-package v-if="['PACKAGE'].includes(typeCode)" :itemId="id" :typeCode="typeCode"></v-assist-package>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import assist from './index.js'
  import vAssistClaim from './AssistClaim.vue'
  import vAssistDeed from './AssistDeed.vue'
  import vAssistPackage from './AssistPackage.vue'

  export default {
    name: 'assist-page',
    components: {vAssistClaim, vAssistDeed, vAssistPackage},
    data: () => ({
      id: null,
      typeCode: null
    }),
    props: {
      itemId: {
        type: String,
        default: null
      },
      fullscreen: {
        type: Boolean,
        default: false
      },
      mode: {
        type: String,
        default: 'page'
      }
    },
    created () {
    },
    mounted () {
      if (this.itemId) {
        this.fetchData(this.itemId)
      }
    },
    watch: {
      itemId: function (newVal, oldVal) { // watch it
        if (newVal) {
          this.fetchData(newVal)
        } else {

        }
      }
    },
    computed: {
      ...mapGetters({
      })
    },
    methods: {
      fetchData (itemId) {
        if (itemId) {
          if (assist.getTypeCode(itemId)) {
            this.typeCode = assist.getTypeCode(itemId)
            this.id = null
          } else {
            this.$store.dispatch('getAssistMatter', itemId).then(
              (item) => {
                this.typeCode = item.typeCode
                this.id = itemId
              },
              () => {}
            )
          }
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// AssistPage.vue?454de258